import { Star } from "lucide-react";
import { MAX_RATING } from "../../Database/RekebishaMembers/reviews";

/**
 * Star rating, read-only by default. Pass `onChange` to make it a picker — used by the
 * review composer, where every star is a tap target. Web port of the app's
 * components/StarRating.js.
 */
const StarRating = ({ value = 0, size = 18, onChange, className = "" }) => (
  <div className={`flex items-center gap-1 ${className}`}>
    {Array.from({ length: MAX_RATING }, (_, index) => {
      const position = index + 1;
      const filled = onChange ? value >= position : value >= position - 0.5;

      const star = (
        <Star
          className={filled ? "text-brandgreen fill-current" : "text-gray-300"}
          style={{ width: size, height: size }}
        />
      );

      if (!onChange) {
        return <span key={position}>{star}</span>;
      }

      return (
        <button
          key={position}
          type="button"
          onClick={() => onChange(position)}
          aria-label={`Rate ${position} out of ${MAX_RATING}`}
          className="hover:scale-110 transition-transform"
        >
          {star}
        </button>
      );
    })}
  </div>
);

export default StarRating;
